import { MyleTableColumn } from "@/Common/Components/Tables/MyleTableColumn";
import { FaxLabRequestComposite } from "@/Common/Models/Faxing/FaxLabRequestComposite";
import { PortfolioExamRequestSortOrderType, RedirectTo, SortDirection } from "@/Common/Models/UI/Enums";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { RouterHistory } from "@/Common/Utilities/Router/RouterHistory";
import { MyRequestsTableItem } from "@/Portfolio/Models/MyNotesInboxTableItem";
import { PortfolioStore } from "@/Portfolio/Stores/PortfolioStore";

class RequestsInboxHandler extends BaseOperationHandler {
    constructor() {
        super();
        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_SearchBoxTextChanged, this.Seacrh_TextChanged);
        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_CloseRequestPopup, this.CloseRequestPopup);
        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_LoadPatientInfo, this.LoadPatientInfo);
        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_DeleteSelectedRequest, this.DeleteSelectedRequest);
        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_PrintSelectedRequest, this.GeneratedSelectedRequestPdf);
        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_Search_CurrentPageChange, this.ResultsPageChange);
        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_SearchSettings_OnResultsPerPageChange, this.ResultsPerPageChange);
        this.RegisterOperation(LocalOperations.Misc.MyleApp_Container_Click, this.ClosePopups, false);
        this.RegisterOperation(LocalOperations.Misc.Table_ColumnSortClick, this.SetColumnSort);
        this.RegisterOperation(LocalOperations.Portfolio.LabRequest_CloseSignFaxPopup, this.closeLabRequestPopups);
        this.RegisterOperation(LocalOperations.Portfolio.LabRequest_OpenSignFaxPopup, this.openLabRequestPopups);
        this.RegisterOperation(LocalOperations.Portfolio.LabRequest_Fax, this.sendLabRequestFax);
        this.RegisterOperation(LocalOperations.Portfolio.LabRequest_CloseFaxResponsePopup, this.closeFaxLabRequestResponse);
        this.RegisterOperation(LocalOperations.Portfolio.MyRequests_OnPatientClick, this.onPatientClick);
    }

    private SetColumnSort(request: LocalEvent, store: PortfolioStore): void {
        var tableTarget = request.Get<MyleTableTarget>("target");

        if (tableTarget === MyleTableTarget.Myle_PortfolioMyRequests_Search_ColumnSortClick) {
            var columnOrderType = request.Get<PortfolioExamRequestSortOrderType>("sortColumn");

            if (store.RequestsInboxModel.get("OrderByColumn") && store.RequestsInboxModel.get("OrderByColumn") === columnOrderType) {
                if (store.RequestsInboxModel.get("OrderByDirection") === SortDirection.ASC)
                    store.RequestsInboxModel = store.RequestsInboxModel.set("OrderByDirection", SortDirection.DESC);
                else
                    store.RequestsInboxModel = store.RequestsInboxModel.set("OrderByDirection", SortDirection.ASC);
            }
            else {
                store.RequestsInboxModel = store.RequestsInboxModel.set("OrderByColumn", columnOrderType);
                store.RequestsInboxModel = store.RequestsInboxModel.set("OrderByDirection", SortDirection.ASC);
            }

            var column = request.Get<MyleTableColumn>("columnObject");

            if (column) {
                if (column.columnOptions.IsSortActive) {
                    column.ToggleSortDirection();
                }
                column.columnOptions.IsSortActive = true;
            }

            store.PortfolioActions.LoadMyRequests(store.RequestsInboxModel);
        }
    }

    private ClosePopups(request: LocalEvent, store: PortfolioStore): void {
        if (store.RequestsInboxModel.get("RequestPopupIsVisible") === true) {
            this.CloseRequestPopup(request, store);
            store.EmitChangeToListeners();
        }
    }

    private ResultsPageChange(request: LocalEvent, store: PortfolioStore): void {
        var value = request.Get<number>("Page");
        store.RequestsInboxModel = store.RequestsInboxModel.set("SelectedPageNumber", value);
        store.PortfolioActions.LoadMyRequests(store.RequestsInboxModel);
    }

    private ResultsPerPageChange(request: LocalEvent, store: PortfolioStore): void {
        store.RequestsInboxModel = store.RequestsInboxModel
            .set("SelectedPageNumber", 1)
            .set("SelectedPageSizeOption", request.Get<number>("value"));
    }

    private GeneratedSelectedRequestPdf(request: LocalEvent, store: PortfolioStore): void {
        let justRerenderIframe = request.Get<boolean>("justRerenderIframe");
        let includeSignature = request.Get<boolean>("includeSignature");
        var labName = request.Get<string>("labName");
        var labFax = request.Get<string>("labFax");

        store.PortfolioActions.PrintSelectedRequest(store.RequestsInboxModel.get("RequestId"), includeSignature, justRerenderIframe, labName, labFax);
        if (!justRerenderIframe)
            store.RequestsInboxModel = store.RequestsInboxModel.set("IsLabFaxPopupOpen", false);
        sessionStore.hideGlobalOverlay();
    }

    private DeleteSelectedRequest(request: LocalEvent, store: PortfolioStore): void {
        var requestId = store.RequestPopupDataModel.get("RequestId");
        store.PortfolioActions.DeleteSelectedRequest(requestId);
    }

    private Seacrh_TextChanged(request: LocalEvent, store: PortfolioStore): void {
        store.RequestsInboxModel = store.RequestsInboxModel.set("SelectedPageNumber", 1);
        store.RequestsInboxModel = store.RequestsInboxModel.set("GlobalPortfolioSearchText", request.Get<string>("value"));
        store.PortfolioActions.LoadMyRequests(store.RequestsInboxModel);
    }

    private CloseRequestPopup(request: LocalEvent, store: PortfolioStore): void {
        store.RequestsInboxModel = store.RequestsInboxModel.set("RequestPopupIsVisible", false);

        sessionStore.hideGlobalOverlay();
    }

    private LoadPatientInfo(request: LocalEvent, store: PortfolioStore): void {
        var patientId = request.Get<string>("id");
        store.ExpectedResponseStore.LoadPatientRequest = store.PortfolioActions.LoadPatientInfo(patientId, SubServerOperations.Portfolio.LoadPatientRequest);
    }

    private closeLabRequestPopups(request: LocalEvent, store: PortfolioStore): void {
        store.RequestsInboxModel = store.RequestsInboxModel.set("IsLabFaxPopupOpen", false);
        store.RequestsInboxModel = store.RequestsInboxModel.set("LabRequestFaxModel", null);
        store.RequestsInboxModel = store.RequestsInboxModel.set("LabRequestPreviewPDFURLFileName", null);
        store.RequestsInboxModel = store.RequestsInboxModel.set("LabRequestPreviewPDFURL", null);

        sessionStore.hideGlobalOverlay();
    }

    private sendLabRequestFax(request: LocalEvent, store: PortfolioStore): void {
        var requestId = request.Get<string>("RequestId");
        var pdfName = request.Get<string>("pdf");
        var labName = request.Get<string>("labName");
        var labAddress = request.Get<string>("labAddress");
        var labPhone = request.Get<string>("labPhone");
        var labFax = request.Get<string>("labFax");

        let faxLabRequestComposite = new FaxLabRequestComposite({
            Id: requestId,
            PatientId: store.RequestsInboxModel.get("PatientId"),
            FileName: pdfName,
            LabName: labName,
            LabFax: labFax,
            LabPhone: labPhone,
            LabAddress: labAddress
        });

        store.PortfolioActions.SendLabRequestFax(faxLabRequestComposite);
    }

    private closeFaxLabRequestResponse(request: LocalEvent, store: PortfolioStore): void {
        store.RequestsInboxModel = store.RequestsInboxModel.set("LabRequestFaxResponse", null);
        store.RequestsInboxModel = store.RequestsInboxModel.set("LabRequestFaxModel", null);
        store.RequestsInboxModel = store.RequestsInboxModel.set("LabRequestPreviewPDFURLFileName", null);
        store.RequestsInboxModel = store.RequestsInboxModel.set("LabRequestPreviewPDFURL", null);
        sessionStore.hideGlobalOverlay();
    }

    private openLabRequestPopups(request: LocalEvent, store: PortfolioStore): void {
        const requestId = request.Get<string>("requestId");
        store.RequestsInboxModel = store.RequestsInboxModel.set("RequestId", requestId);
        store.RequestsInboxModel = store.RequestsInboxModel.set("LabRequestPreviewPDFURLFileName", null);
        store.RequestsInboxModel = store.RequestsInboxModel.set("LabRequestPreviewPDFURL", null);
        store.PortfolioActions.PrintSelectedRequest(requestId, false, true, "", "");
    }

    public onPatientClick(request: LocalEvent): void {
        let item = request.Get<MyRequestsTableItem>("item");

        window.setTimeout(() => {
            let openPatientOperation = new LocalEvent(LocalOperations.Misc.RedirectToTab);

            openPatientOperation.AddItem("value", item.Model.ContactId);
            openPatientOperation.AddItem("target", RedirectTo.Patient);
            openPatientOperation.AddItem("currentLocation", RouterHistory.location);
            openPatientOperation.AddItem("OpenEncounterId", item.Model.EncounterId);
            openPatientOperation.AddItem("encounterEdit", false);

            LocalEventDispatcher.dispatch(openPatientOperation);
        }, 100);
    }
}

export { RequestsInboxHandler };
